/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkDateTypeDTO
 */
export interface WorkDateTypeDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkDateTypeDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkDateTypeDTO
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkDateTypeDTO
     */
    type?: string;
}

/**
 * Check if a given object implements the WorkDateTypeDTO interface.
 */
export function instanceOfWorkDateTypeDTO(value: object): value is WorkDateTypeDTO {
    return true;
}

export function WorkDateTypeDTOFromJSON(json: any): WorkDateTypeDTO {
    return WorkDateTypeDTOFromJSONTyped(json, false);
}

export function WorkDateTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkDateTypeDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'date': json['date'] == null ? undefined : (new Date(json['date'])),
                  'type': json['type'] == null ? undefined : json['type'],
    };
}

export function WorkDateTypeDTOToJSON(json: any): WorkDateTypeDTO {
    return WorkDateTypeDTOToJSONTyped(json, false);
}

export function WorkDateTypeDTOToJSONTyped(value?: WorkDateTypeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'date': value['date']?.toISOString(),
        'type': value['type'],
    };
}


